import "./Business.css";
import { Card, Col, Row } from "react-bootstrap";
import { saveAs } from "file-saver";
import {
  setComeFromPage,
  setStripeSuccessPopUp,
} from "../../../redux/payment/payment";
import { setRefetchSpecificUser } from "../../../redux/multicommunity/multicommunity.js";
import { showPayoutDetailsAtom } from "../../../store/globalstore";
import { showNotificationToast, toastify } from "../../../helpers/toast/toastify.js";
import { useAtom } from "jotai";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import AccountStats from "../../newDashBoard/AccoutStats/AccountStats";
import BubbleSvgButton from "../CommonComponents/BubbleSvgButton/BubbleSvgButton";
import check from "../../../assets/images/check.svg";
// import CommunityBarChart from "../MarketPlace/CommunityBarChart";
import CommunityAreaChart, { CommunityAreaChartTabs } from "../MarketPlace/CommunityAreaChart";
import CustomSwitch from "../CommonComponents/CustomSwitch/CustomSwitch.jsx";
import download from "../../../assets/images/download.svg";
import FloatingDropdownWithArrow from "../CommonComponents/FloatingDropdownWithArrow/FloatingDropdownWithArrow.jsx";
import FloatingTextFiled from "../CommonComponents/FloatingTextFiled/FloatingTextFiled";
import GetYourOwnApp from "./GetYourOwnApp.jsx";
import InfoPopup from "../CommonComponents/InfoPopup/InfoPopup";
import PayoutSetupModal from "./PayoutSetupModal/index.jsx";
import SearchBar from "../CommonComponents/SearchBar/SearchBar";
import TablePagination from "../CommonComponents/NewPagination/NewPagination";
import useApi from "../../../helpers/apiHelper/requestHelper";
import { storeUser, updateUser } from "../../../redux/users/usersSlice.js";

import {
  fetchUser,
  isOlderThan7Days,
  isValidTRC20AddressLength,
} from "../../../helpers/helper.js";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import LoadingOverlay from "../LoadingOverlay/index.jsx";
import {
  ArrowDropDownIcon,
  DatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

const cards = [
  { cardTitle: "Income" },
  { cardTitle: "Monthly growth" },
  { cardTitle: "Total subscribers" },
  { cardTitle: "Reports" },
];

const walletOptions = ["Get paid in crypto", "Get paid in USD"];

// Year Selector Component
const YearSelector = ({ selectedYear, setSelectedYear, open, setOpen }) => {
  const closingRef = useRef(false);
  return (
    <div className="yearSelectBox">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          open={open}
          onClose={() => {
            closingRef.current = true;
            setOpen(false);
            setTimeout(() => { closingRef.current = false; }, 300);
          }}
          onOpen={() => {
            if (!closingRef.current) setOpen(true);
          }}
          onAccept={() => {
            closingRef.current = true;
            setOpen(false);
            setTimeout(() => { closingRef.current = false; }, 300);
          }}
          label="Select Year"
          value={selectedYear ? dayjs().year(selectedYear) : null}
          onChange={(date) => {
            if (date) {
              setSelectedYear(date.year());
            } else {
              setSelectedYear(null);
            }
            closingRef.current = true;
            setOpen(false);
            setTimeout(() => { closingRef.current = false; }, 300);
          }}
          maxDate={dayjs()}
          openTo="year"
          views={["year"]}
          yearsOrder="desc"
          slots={{
            openPickerIcon: ArrowDropDownIcon,
          }}
          slotProps={{
            textField: {
              className: `yearlyDatePicker ${selectedYear ? "bg-white" : ""}`,
              placeholder: "Select year",
              size: "small",
              inputProps: {
                readOnly: true,
                InputLabelProps: { shrink: true },
                style: {
                  cursor: "pointer",
                  fontSize: "14px",
                  fontFamily: "Graphik Medium",
                },
              },
              sx: {
                "& .MuiFormLabel-root": {
                  fontSize: "14px",
                  fontFamily: "Graphik Medium",
                  color: "#9A9B9B",
                  paddingTop: "6px",
                },
                "& .MuiOutlinedInput-root": {
                  minHeight: "55px",
                  fontSize: "14px",
                  color: "#9A9B9B",
                  fontFamily: "Graphik Medium",
                  borderRadius: "12px",
                  backgroundColor: selectedYear ? "#ffffff" : "#f7f7f7",
                  "& fieldset": {
                    borderColor: selectedYear ? "#11B700" : "transparent",
                    borderWidth: "2px",
                    borderRadius: "12px",
                    fontFamily: "Graphik Medium",
                  },
                  "&:hover": {
                    backgroundColor: "#ffffff",
                  },
                  "&:hover fieldset": {
                    borderColor: selectedYear ? "#11B700" : "#ccc",
                    borderWidth: "2px",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#11B700",
                    borderWidth: "2px",
                  },
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

const ExactDateSelector = ({ selectedDate, setSelectedDate, minDate, maxDate, label = "Select Date" }) => {
  const [open, setOpen] = useState(false);
  const closingRef = useRef(false);

  const closePicker = () => {
    closingRef.current = true;
    setOpen(false);
    setTimeout(() => { closingRef.current = false; }, 300);
  };

  useEffect(() => {
    if (selectedDate) setOpen(false);
  }, [selectedDate]);

  const handleClear = (e) => {
    e.stopPropagation();
    setSelectedDate(null);
  };

  return (
    <div
      className="exactDateSelectBox"
      style={{ position: "relative" }}
      onClick={() => {
        if (!closingRef.current) setOpen(true);
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          className="memberDropDown"
          open={open}
          onOpen={() => {
            if (!closingRef.current) setOpen(true);
          }}
          onClose={closePicker}
          onAccept={closePicker}
          label={label}
          format="DD-MM-YYYY"
          value={selectedDate}
          onChange={(date) => { setSelectedDate(date); closePicker(); }}
          {...(dayjs.isDayjs(minDate) ? { minDate } : {})}
          {...(dayjs.isDayjs(maxDate) ? { maxDate } : {})}
          slotProps={{
            textField: {
              className: `yearlyDatePicker ${selectedDate ? "bg-white" : ""}`,
              placeholder: label,
              size: "small",
              onClick: (e) => {
                e.stopPropagation();
                if (!closingRef.current) setOpen(true);
              },
              sx: {
                width: "100%",
                "& .MuiFormLabel-root": {
                  fontSize: "14px",
                  fontFamily: "Graphik Medium",
                  color: "#9A9B9B",
                  paddingTop: "6px",
                },
                "& .MuiOutlinedInput-root": {
                  minHeight: "55px",
                  fontSize: "14px",
                  color: "#9A9B9B",
                  fontFamily: "Graphik Medium",
                  borderRadius: "12px",
                  backgroundColor: selectedDate ? "#ffffff" : "#f7f7f7",
                  "& fieldset": {
                    borderColor: selectedDate ? "#11B700" : "transparent",
                    borderWidth: "2px",
                    borderRadius: "12px",
                    fontFamily: "Graphik Medium",
                  },
                  "&:hover": {
                    backgroundColor: "#ffffff",
                  },
                  "&:hover fieldset": {
                    borderColor: selectedDate ? "#11B700" : "#ccc",
                    borderWidth: "2px",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#11B700",
                    borderWidth: "2px",
                  },
                },
              },
            },
          }}
          slots={{ openPickerIcon: ArrowDropDownIcon }}
        />
      </LocalizationProvider>
      {selectedDate && (
        <IconButton
          onClick={handleClear}
          size="small"
          sx={{
            backgroundColor: "#fff",
            position: "absolute",
            right: "4px",
            top: "50%",
            transform: "translateY(-50%)",
            padding: "10px",
            zIndex: 1,
            "&:hover": { backgroundColor: "#f1f1f1" },
          }}
        >
          <CloseIcon sx={{ fontSize: "18px", color: "#9A9B9B" }} />
        </IconButton>
      )}
    </div>
  );
};

const BusinessListening = () => {
  // const [activeButton, setActiveButton] = useState("Day");
  // const [activeButtons, setActiveButtons] = useState({ 0: "Day", 1: "Day", 2: "Day" });
  const [activeTabs, setActiveTabs] = useState({ 0: 0, 1: 0, 2: 0 });
  const [allowEdit, setAllowEdit] = useState(false);
  const [crptoWallet, setCrptoWallet] = useState();
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [history, setHistory] = useState([]);
  const [isAddButtonClicked, setIsAddButtonClicked] = useState(false);
  const [isDeleteCryptoWallet, setIsDeleteCryptoWallet] = useState(false);
  const [isCreatingWallet, setIsCreatingWallet] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);
  // CHANGED: was useState(false) — on mobile the useEffect would immediately flip this to
  // true, causing GetYourOwnApp to mount then unmount (visible layout jerk). Lazy init
  // reads the real viewport width on first render so no remount ever happens.
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 576);
  const [openCards, setOpenCards] = useState(Array(cards.length).fill(true));
  const [optimisticEmailReport, setOptimisticEmailReport] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const location = useLocation();
  const [selectedValue, setSelectedValue] = useState("");
  const [showPayoutDetails, setShowPayoutDetails] = useAtom(showPayoutDetailsAtom);
  
  // New state for USD options modal
  const [showUSDOptionsModal, setShowUSDOptionsModal] = useState(false);
  const [usdPayoutHistory, setUsdPayoutHistory] = useState([]);
  const [isRestoringUSD, setIsRestoringUSD] = useState(false);
  
  // New state for date filtering
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [openYearPicker, setOpenYearPicker] = useState(false);
  const [activeTab, setActiveTab] = useState("monthly");
  const [downloadingKey, setDownloadingKey] = useState(null);
  
  const [searchParams] = useSearchParams();
  const id = searchParams.get("accountId");
  const navigate = useNavigate();
  const community = useSelector((state) => state?.user?.user?.leaderCommunity);

  const [monthlyReportUpdated, setMonthlyReportUpdated] = useState(false);
  const [showSuccessfullPopUp, setShowSuccessfullPopUp] = useState(false);

  const { user } = useSelector((state) => state.user);

  const api = useApi();
  const dispatch = useDispatch();
  const usdtInputRef = useRef(null);
  const hasPayoutSetup = user?.getPaidInCrypto || user?.getPaidInUSD;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      setShowPayoutDetails(false);
    };
  }, []);

  useEffect(() => {
    if (user) {
      if (user?.getPaidInCrypto) {
        setSelectedValue(walletOptions[0]);
        setCrptoWallet(user?.usdtWalletAddress || "");
      } else if (user?.getPaidInUSD) {
        setSelectedValue(walletOptions[1]);
        setCrptoWallet("");
      } else {
        setSelectedValue(null);
        setCrptoWallet("");
      }
      
      // Set USD payout history
      if (user?.payoutHistory && Array.isArray(user.payoutHistory)) {
        setUsdPayoutHistory(user.payoutHistory);
      }
    }
  }, [user]);
  useEffect(() => {
    // Reset all modal states when user changes
    setIsAddButtonClicked(false);
    setShowSuccessfullPopUp(false);
    setIsRedirecting(false);
    setIsCreatingWallet(false);
    setIsDeleteCryptoWallet(false);
    setShowUSDOptionsModal(false);
    setAllowEdit(false);
  }, [user]);

  useEffect(() => {
    if (id) {
      checkStripeAccount();
    }
  }, [id]);

  const checkStripeAccount = async () => {
    try {
      const response = await api("post", "users/checkAccount", {
        sendEmail: true,
      });
      if (response?.status && !(response.message === "Connect Onboarding is not completed!")) {
        await Promise.all([fetchUser(api, dispatch, storeUser)]);

        const returnUser = response?.data.user;
        // showNotificationToast("Payment information updated!", "Your payment info was just updated.\n\nIf it wasn't you, act fast:\n1) Change your password\n2) Enable OTP (if not already)\n3) Review and update payment details\n4) Consider updating your email password\n\nNeed help? Contact support.");
        if (returnUser?.getPaidInUSD) {
          navigate("/leader/payment", { replace: true });
          dispatch(setComeFromPage(null));
          dispatch(setStripeSuccessPopUp(true));
          return;
        }
      } else {
        navigate(location.pathname, { replace: true });
      }
    } catch (error) {
      console.error("Error:", error);
      toastify("An error occurred. Please try again.", "error");
    }
  };

  useEffect(() => {
    if (selectedValue === walletOptions[0] && !user?.getPaidInCrypto) {
      setAllowEdit(true);
      focusUsdtInput();
    }
  }, [selectedValue]);

  const changeWalletAddress = async () => {
    if (crptoWallet?.trim() === "") {
      toastify("Wallet can't empty");
      return;
    }
    if (!isValidTRC20AddressLength(crptoWallet)) {
      toastify("Please enter a valid Wallet Address");
      return;
    }
    setAllowEdit(false);
    setIsCreatingWallet(true);
    const response = await api("post", "users/update", {
      usdtWalletAddress: crptoWallet,
      getPaidInUSD: false,
      getPaidInCrypto: true,
      fromPayoutSetup:true
    });
    
    if (response?.status) {
      setTimeout(async () => {
        await fetchUser(api, dispatch, storeUser);
        // if (response?.data?.updatedPayoutInfo) {
        //   showNotificationToast("Payment information updated!", "Your payment info was just updated.\n\nIf it wasn't you, act fast:\n1) Change your password\n2) Enable OTP (if not already)\n3) Review and update payment details\n4) Consider updating your email password\n\nNeed help? Contact support.");
        // }
        setIsCreatingWallet(false);
        setShowSuccessfullPopUp(true);
      }, 3000);
    } else {
      setIsCreatingWallet(false);
    }
  };

  function getMonthsAndYearsFromDate(startDate) {
    const currentDate = new Date();
    const monthsAndYears = [];

    let currentDatePointer = new Date(startDate);

    while (
      currentDatePointer.getFullYear() < currentDate.getFullYear() ||
      (currentDatePointer.getFullYear() === currentDate.getFullYear() &&
        currentDatePointer.getMonth() <= currentDate.getMonth())
    ) {
      const formattedDate = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
      }).format(currentDatePointer);

      const isCurrentMonth = 
        currentDatePointer.getFullYear() === currentDate.getFullYear() &&
        currentDatePointer.getMonth() === currentDate.getMonth();

      monthsAndYears.push({
        display: formattedDate,
        date: new Date(currentDatePointer),
        year: currentDatePointer.getFullYear(),
        month: currentDatePointer.getMonth(),
        isCurrentMonth,
      });

      currentDatePointer.setMonth(currentDatePointer.getMonth() + 1);
    }

    return monthsAndYears;
  }

  useEffect(() => {
    const startDate = new Date(user?.leaderCommunity?.createdAt);
    const result = getMonthsAndYearsFromDate(startDate);
    setHistory(result);
    setFilteredHistory(result);
  }, [user?.leaderCommunity?.createdAt]);

  useEffect(() => {
    if (user?.leaderCommunity?.receiveEmailReport !== undefined) {
      setOptimisticEmailReport(null);
    }
  }, [user?.leaderCommunity?.receiveEmailReport]);

  const isSameDate = (date1, date2) => {
    if (!date1 || !date2) return false;
    const d1 = dayjs(date1);
    const d2 = dayjs(date2);
    return d1.format("YYYY-MM-DD") === d2.format("YYYY-MM-DD");
  };

  useEffect(() => {
    const filterData = (data, selectedYear, selectedDate) => {
      let filtered = data;

      if (selectedYear) {
        filtered = filtered.filter((item) => item.year === selectedYear);
      }

      if (selectedDate) {
        filtered = filtered.filter((item) => {
          const itemDate = dayjs(item.date);
          const targetDate = dayjs(selectedDate.toDate());
          return (
            itemDate.year() === targetDate.year() &&
            itemDate.month() === targetDate.month()
          );
        });
      }

      return filtered;
    };

    setFilteredHistory(filterData(history, selectedYear, selectedDate));
  }, [history, selectedYear, selectedDate]);

  const downloadCsv = async (date) => {
    const key = `monthly-${date}`;
    setDownloadingKey(key);
    try {
      const response = await api("post", "users/getMonthlyReport", { date });
      if (response?.success) {
        const base64Data = response.base64File;
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, `${date ? "Report - " + date : "Report - All"}.xlsx`);
      } else {
        toastify("No report found");
      }
    } finally {
      setDownloadingKey(null);
    }
  };

  const downloadPayoutCsv = async (date) => {
    const key = `payout-${date}`;
    setDownloadingKey(key);
    try {
      const response = await api("post", "users/getPayoutHistory", { date });

      if (response?.success) {
        const base64Data = response.base64File;
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, `${date ? "Report - " + date : "Report - All"}.xlsx`);
      } else {
        toastify("No report found");
      }
    } finally {
      setDownloadingKey(null);
    }
  };

  const focusUsdtInput = () => {
    setTimeout(() => {
      usdtInputRef?.current?.focus();
      usdtInputRef?.current?.click();
    }, 400);
  };

  const handleNewWalletPayout = () => {
    setAllowEdit(true);
    setCrptoWallet("");
    setSelectedValue(walletOptions[0]);
    focusUsdtInput();
  };

  const handleNewUSDPayout = async (isNewSetup = true) => {
    if (isNewSetup) {
      setIsRedirecting(true);
      if(user?.stripeCredentials?.stripeAccountId&&user?.stripeCredentials?.detailsSubmitted&&user?.stripeCredentials?.payoutsEnabled&&user?.stripeCredentials?.chargesEnabled){
        const response=await api("post", "users/deleteOldAccount");
        await fetchUser(api, dispatch, storeUser);
           
        window.location.assign(response?.data?.user?.stripeCredentials?.stripeAccountLink);
       setIsRedirecting(false);
      }
     
      await handleStripeButtonClick();
    }
    setTimeout(() => {
      setSelectedValue(walletOptions[1]);
    }, 3000);
  };

  const handleRestoreUSDSetup = async () => {
    if (!usdPayoutHistory || usdPayoutHistory.length === 0) {
      toastify("No previous USD setup found", "error");
      return;
    }

    const lastStripeAccount = usdPayoutHistory[usdPayoutHistory.length - 1];
    
    setShowUSDOptionsModal(false);
    setIsRestoringUSD(true);

    try {
      const response = await api("post", "users/restoreOldUSDSetup", {
        stripeAccountId: lastStripeAccount.stripeAccountId,
      });

      if (response?.status) {
        await fetchUser(api, dispatch, storeUser);
        setIsRestoringUSD(false);
        setSelectedValue(walletOptions[1]);
        dispatch(setStripeSuccessPopUp(true));
      } else {
        setIsRestoringUSD(false);
        toastify(response?.message || "Failed to restore USD setup", "error");
      }
    } catch (error) {
      setIsRestoringUSD(false);
      toastify("Failed to restore USD setup", "error");
    }
  };

  const handleUSDOptionSelect = async (option) => {
    setShowUSDOptionsModal(false);
    
    if (option === 'restore') {
      await handleRestoreUSDSetup();
    } else if (option === 'new') {
      await handleNewUSDPayout(true);
    }
  };

  const popupAction = async (action) => {
    setIsAddButtonClicked(false);
    
    if (hasPayoutSetup) {
      if (action === "USD") {
        // Check if there's any USD payout history
        if (usdPayoutHistory && usdPayoutHistory.length > 0) {
          // Show modal only if history exists
          setShowUSDOptionsModal(true);
          
        }
        // else if(user?.stripeCredentials?.stripeAccountId&&user?.stripeCredentials?.stripeAccountLink&&(!user?.stripeCredentials?.chargesEnabled||!user?.stripeCredentials?.payoutsEnabled||!user?.stripeCredentials?.detailsSubmitted)){
        //     window.location.assign(user?.stripeCredentials?.stripeAccountLink);
        // }
         else {
          // Directly redirect to Stripe if no history
          setIsRedirecting(true);
          try {
            await api("post", "users/deleteOldAccount");
            await fetchUser(api, dispatch, storeUser);
           await handleNewUSDPayout(true);
          } catch (error) {
            toastify("Failed to delete old account");
            setIsRedirecting(false);
            return;
          }
        }
        return;
      } else if (action === "New wallet") {
        setIsDeleteCryptoWallet(true);
      }
  
      try {
        await api("post", "users/deleteOldAccount");
        await fetchUser(api, dispatch, storeUser);
        if (action === "New wallet") {
          setTimeout(() => {
            setIsDeleteCryptoWallet(false);
            handleNewWalletPayout();
          }, 3000);
        }
      } catch (error) {
        toastify("Failed to delete old account");
        setIsDeleteCryptoWallet(false);
        setIsRedirecting(false);
        return;
      }
    } else {
      if (action === "New wallet") {
        handleNewWalletPayout();
      } else if (action === "USD") {
        // Check if there's any USD payout history
        if (usdPayoutHistory && usdPayoutHistory.length > 0) {
          // Show modal only if history exists
          setShowUSDOptionsModal(true);
        }
        // else if(user?.stripeCredentials?.stripeAccountId&&user?.stripeCredentials?.stripeAccountLink&&(!user?.stripeCredentials?.chargesEnabled||!user?.stripeCredentials?.payoutsEnabled||!user?.stripeCredentials?.detailsSubmitted)){
        //     window.location.assign(user?.stripeCredentials?.stripeAccountLink);
        //     console.log(user?.stripeCredentials?.stripeAccountLink,"this is a stripe account link")
        // }
         else {
          // Directly redirect to Stripe if no history
          setIsRedirecting(true);
          handleNewUSDPayout(true);
        }
      }
    }
  };

  const handleStripeButtonClick = async () => {
    const response = await api("post", "users/checkAccount?from=bussiness");

    const freshUserData = response?.data?.user;
    const stripeLink = freshUserData?.stripeCredentials?.stripeAccountLink;

    if (freshUserData) {
      dispatch(updateUser(freshUserData));
    }
    if (stripeLink) {
      window.location.assign(stripeLink);
    } else {
      toastify("Could not get Stripe link. Please try again.", "error");
    }
    setIsRedirecting(false);
  };

  const isWalletAddressEditable = allowEdit && selectedValue === walletOptions[0];
 
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {!id ? (
        <div className="businessListingPage DashboardPage">
          <div className="firstRow">
            <AccountStats user={user} businessListing={true} />
            <div className="getYourAppWrapper">
              {!isMobile && <GetYourOwnApp />}
            </div>
          </div>
          <div
            className={`addVipMemberBox businessListingPayoutBox ${
              !showPayoutDetails ? "changeHeight" : ""
            }`}
          >
            <div className="row align-items-center">
              <div className="col-12">
                <div className="SwithTitle">
                  <div className="d-flex flex-row mb-0 align-items-center">
                    <CustomSwitch
                      checked={showPayoutDetails}
                      onChange={() => {
                        setShowPayoutDetails(!showPayoutDetails);
                      }}
                    />
                    <span className="switchText ms-3">
                      {showPayoutDetails ? "Hide Details" : "Show Details"}
                    </span>
                  </div>
                  <p className="title businessPayoutTitle">
                    <span>Your payout setup</span>
                    <InfoPopup
                      contentItems={[
                        { text: "Flexible Payout Options", type: "heading" },
                        {
                          text: "Subscribers pay for your service in USD via credit card. You decide how you'd like to receive payouts: either in USD with instant withdrawals (after a one-time setup) or in USDT, paid bi-weekly via manual processing.",
                          type: "paragraph",
                        },
                      ]}
                    />
                  </p>
                </div>
              </div>
            </div>
            {showPayoutDetails && (
              <div className="row mt-3 gap-3">
                <div className="col-lg-3 col-md-6 col-12">
                  <div className="fixedWidth1440 mx-auto">
                    <FloatingDropdownWithArrow
                      className={`accessTimeDropDown`}
                      id="accessTimeDropDown"
                      label="Get paid in crypto / USD"
                      options={walletOptions}
                      disabled={hasPayoutSetup}
                      selectedValue={selectedValue}
                      setSelectedValue={async (value) => {
                        setSelectedValue(value);
                        if (value === "Get paid in USD") {
                          await popupAction("USD");
                        }
                      }}
                    />
                  </div>
                </div>

                {selectedValue === walletOptions[0] && (
                  <div className="col-lg-6 col-md-6 col-12">
                    <FloatingTextFiled
                      ref={usdtInputRef}
                      className={`VipMemberEmail usdtAddressInputField`}
                      forLabel="usdtAddressField"
                      id="usdtAddressField"
                      label="USDT address (TRC20)"
                      placeholder="Enter USDT address"
                      disabled={!allowEdit}
                      onChange={(e) => {
                        setCrptoWallet(e.target.value);
                      }}
                      value={crptoWallet}
                    />
                  </div>
                )}
                {selectedValue === walletOptions[1] && user?.getPaidInUSD && (
                  <div className="col-lg-3 col-md-6 col-12">
                    <BubbleSvgButton
                      onClick={handleStripeButtonClick}
                      text={"Connected"}
                      type="button"
                      variant="black"
                      subText="stripe"
                      disabled={!allowEdit}
                      spanTextStyling={{
                        fontFamily: "Graphik Regular",
                        lineHeight: "20px",
                        marginTop: "2px",
                      }}
                      spansubTextStyling={{
                        fontSize: "16px",
                        fontFamily: "Graphik Bold",
                        lineHeight: "20px",
                        letterSpacing: "-0.4px",
                      }}
                      svgIcon={
                        <img
                          alt="connected icon"
                          src={check}
                          style={{
                            width: "21px",
                            height: "21px",
                          }}
                        />
                      }
                      svgPosition="right"
                      containerStyling={{
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "9px",
                        padding: 0,
                      }}
                    />
                  </div>
                )}
                
                {(hasPayoutSetup || isWalletAddressEditable) && (
                  <div className="col-lg-3 col-md-6 col-12 fixedWidth1440 ms-auto">
                    <BubbleSvgButton
                      onClick={() => {
                        if (isWalletAddressEditable) {
                          changeWalletAddress();
                        } else {
                          setIsAddButtonClicked(true);
                        }
                      }}
                      text={isWalletAddressEditable ? "Save" : "Change"}
                      type="button"
                      variant={isWalletAddressEditable ? "green" : "red"}
                      containerStyling={{
                        justifyContent: "center",
                      }}
                    />
                  </div>
                )}
              </div>
            )}
          </div>

          {cards.map((card, index) => (
            <div
              className={`detailShowCard addVipMemberBox ${
                openCards[index] && "detailShowCardSpacing"
              }`}
              key={index}
            >
              <Row className="align-items-center">
                <Col
                  md="6"
                  sm="12"
                  className="mb-md-0 mb-4"
                >
                  <p className="cardTitle mb-2">{card.cardTitle}</p>
                  <div className="SwithTitle d-flex flex-row mb-0">
                    <CustomSwitch
                      checked={openCards[index]}
                      onChange={() => {
                        setOpenCards((prev) => {
                          const updated = [...prev];
                          updated[index] = !updated[index];
                          return updated;
                        });
                      }}
                    />
                    <span className="switchText">
                      {openCards[index] ? "Hide Details" : "Show Details"}
                    </span>
                  </div>
                </Col>
                <Col md="6" sm="12" className="text-end position-relative">
                  {index === 3 && openCards[index] && (
                    <div className="d-flex align-items-center justify-content-end gap-3">
                      <ExactDateSelector
                      user={user}
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        minDate={user?.createdAt}
                        maxDate={dayjs()}
                      />
                    </div>
                  )}
                  {(index === 0 || index === 1 || index === 2) && openCards[index] && (
                    <div className="topTradingBox justify-content-end">
                      <div className="switchSide p-0 justify-content-sm-end justify-content-center">
                        {/* <div className="switchBase">
                          {["Day", "Week", "Month", "All Time"].map((btn) => (
                            <button key={btn} className={activeButtons[index] === btn ? "active" : ""} onClick={() => setActiveButtons((prev) => ({ ...prev, [index]: btn }))}>
                              {btn === "Day" ? "Daily" : btn === "Week" ? "Weekly" : btn === "Month" ? "Monthly" : "All Time"}
                            </button>
                          ))}
                        </div> */}
                        <CommunityAreaChartTabs
                          activeTab={activeTabs[index] ?? 0}
                          onTabChange={(tab) => setActiveTabs((prev) => ({ ...prev, [index]: tab }))}
                        />
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
              {openCards[index] && (
                <>
                  {(index === 0 || index === 1 || index === 2) && (
                    <>
                      <div className="d-flex flex-column monthlyIncome">
                        <div className="chartBox p-0 pt-3">
                          {/* <CommunityBarChart duration={activeButtons[index]} graphType={index === 0 ? "income" : index === 1 ? "growth" : "subscribers"} userId={user?._id} /> */}
                          <CommunityAreaChart
          bare
          graphType={index === 0 ? "income" : index === 1 ? "growth" : "subscribers"}
                            userId={user?._id}
                            activeTab={activeTabs[index] ?? 0}
                            onTabChange={(tab) => setActiveTabs((prev) => ({ ...prev, [index]: tab }))}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {index === 3 && (
                    <>
                      <div className="performanceHistoty reportHistory">
                        <div className="performanceTitleWrap  d-flex justify-content-md-between align-items-center justify-content-center">
                          <div className="performanceTitle align-items-center d-flex gap-4">
                            <p
                              className={activeTab === "monthly" ? "active" : ""}
                              onClick={() => setActiveTab("monthly")}
                              style={{ cursor: "pointer" }}
                            >
                              Monthly Performance
                            </p>
                            <p
                              className={activeTab === "payout" ? "active" : ""}
                              onClick={() => setActiveTab("payout")}
                              style={{ cursor: "pointer" }}
                            >
                              Payout History
                            </p>
                          </div>
                        </div>
                        {filteredHistory.length > 0 ? (
                          filteredHistory.map((item, idx) => (
                            <Card
                              key={idx}
                              className="rounded-0 border-0 border-bottom report"
                            >
                              <Card.Body className="px-0">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="d-flex align-items-center assetColumn">
                                    <h6 className="mb-0">
                                      {item.display}
                                      {item.isCurrentMonth && (
                                        <span style={{ 
                                          fontSize: "10px", 
                                          marginLeft: "8px", 
                                          color: "#666",
                                          fontFamily: "Graphik Regular"
                                        }}>
                                          (In Progress)
                                        </span>
                                      )}
                                    </h6>
                                  </div>
                                  <button
                                    type="button"
                                    className={`download-btn${item.isCurrentMonth ? " current-month" : ""}`}
                                    disabled={!!downloadingKey}
                                    onClick={async () => {
                                      if (item.isCurrentMonth) {
                                        toastify(
                                          `Data for ${item.display} will be available once the month completed.`,
                                          "info"
                                        );
                                        return;
                                      }

                                      if (activeTab === "monthly") {
                                        await downloadCsv(item.display);
                                      } else {
                                        await downloadPayoutCsv(item.display);
                                      }
                                    }}
                                  >
                                    {downloadingKey ===
                                    `${activeTab}-${item.display}` ? (
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      />
                                    ) : (
                                      <img src={download} alt="" />
                                    )}
                                  </button>
                                </div>
                              </Card.Body>
                            </Card>
                          ))
                        ) : (
                          <div className="text-center py-4">
                            <p className="mb-0">
                              {selectedYear || selectedDate
                                ? "No reports found for the selected date"
                                : "No reports available"}
                            </p>
                          </div>
                        )}
                        <div className="mt-d">
                          <TablePagination />
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          ))}

          <div className="businessMobileApp">
            {isMobile && <GetYourOwnApp />}
          </div>
          <PayoutSetupModal
            isAddButtonClicked={isAddButtonClicked}
            setIsAddButtonClicked={setIsAddButtonClicked}
            isRedirecting={isRedirecting}
            setIsRedirecting={setIsRedirecting}
            isCreatingWallet={isCreatingWallet}
            setIsCreatingWallet={setIsCreatingWallet}
            showSuccessfullPopUp={showSuccessfullPopUp}
            setShowSuccessfullPopUp={setShowSuccessfullPopUp}
            popupAction={popupAction}
            isDeleteCryptoWallet={isDeleteCryptoWallet}
            setIsDeleteCryptoWallet={setIsDeleteCryptoWallet}
            showUSDOptionsModal={showUSDOptionsModal}
            setShowUSDOptionsModal={setShowUSDOptionsModal}
            handleUSDOptionSelect={handleUSDOptionSelect}
            usdPayoutHistory={usdPayoutHistory}
            isRestoringUSD={isRestoringUSD}
          />
        </div>
      ) : (
        <LoadingOverlay />
      )}
    </LocalizationProvider>
  );
};

export default BusinessListening;
